import React from "react";
import { FileText } from "lucide-react";
import { getDisplayFileName } from "../../utils/fileName";

// Wave 3 — professional document header: identity + classification treatment.
// Presentation only; the classification value comes straight from the file
// record and is never derived or guessed on the client.
const FileCardHeader = ({ file }) => (
  <div className="file-card__header">
    <div className="file-card__title-row">
      <span className="file-card__icon-mark" aria-hidden="true">
        <FileText size={22} />
      </span>
      <div>
        <p className="file-card__eyebrow">File details</p>
        <h3>{getDisplayFileName(file) || "Unknown File"}</h3>
      </div>
    </div>

    {file?.classification && (
      <span
        className={`file-card__classification classification-${String(
          file.classification
        ).toLowerCase()}`}
      >
        {file.classification}
      </span>
    )}
  </div>
);

export default FileCardHeader;
